import {ContractFieldGroupService} from '../contract-field-group/contract-field-group.service';
import {Injectable} from '@angular/core';
import {EFieldGroupUsageType} from '../../../form-builder/enums/e-group-usage-type.enum';
import {ScheduleColumn} from '../../interfaces/ScheduleColumn';
import {EFieldType} from '../../../form-builder/enums/e-field-type.enum';

/**
 * Retrieves Field groups with fields and organizes them into ScheduleColumn[].
 */
@Injectable()
export class PossibleScheduleColumnsService {
  /**
   *
   * @param {ContractFieldGroupService} contractFieldGroupsService
   */
  public constructor(private contractFieldGroupsService: ContractFieldGroupService) {}

  /**
   * Get the possible ScheduleColumn[] by passing in the used schedule columns and it will filter out the used columns.
   * @param contractId The contract id to get the possible columns for
   * @param useScheduleColumns The columns already being used.
   * @returns {Promise<ScheduleColumn[]>}
   */
  public getScheduleColumns(contractId, useScheduleColumns: ScheduleColumn[] = []): Promise<ScheduleColumn[]> {
    return new Promise((resolve, reject) => {
      this.contractFieldGroupsService
        .getContractFieldGroups(contractId, EFieldGroupUsageType.FIELD_GROUP, true).then((fieldGroups) => {
        const columns: ScheduleColumn[] = [];
        fieldGroups.forEach((contractFieldGroup) => {
          contractFieldGroup.field_group.fields.forEach((field) => {
            const columnAlreadyUsed = useScheduleColumns.find((scheduleColumn) =>
              scheduleColumn.field_id === field.id &&
              scheduleColumn.contract_field_group_id === contractFieldGroup.id)
              != null;
            if (!columnAlreadyUsed && field.type !== EFieldType.CALCULATION)
              columns.push({
                field_id: field.id,
                field: field,
                contract_id: contractId,
                contract_field_group_id: contractFieldGroup.id,
                contract_field_group: contractFieldGroup
              });
          });
        });
        resolve(columns);
      });
    });

  }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/contract/services/possible-schedule-columns/possible-schedule-columns.service.ts